import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BreadcrumbItem from './BreadcrumbItem';

type Props = {
  onClick?: () => void;
}

const BreadcrumbHomeItem = ({ onClick }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // render
  return (
    <BreadcrumbItem to="/" onClick={onClick} >
      <span className="d-none d-sm-inline">
        <FontAwesomeIcon icon="home" />
      </span>
      <span className="d-sm-none ml-2">{tLabels("breadcrumbs.home")}</span>
    </BreadcrumbItem>
  )
}

export default BreadcrumbHomeItem;